import Asistente from 'components/asistente/Asistente'
import React from 'react'
import { Col, Row } from 'reactstrap'

function ViewAsistente() {
  return (
    <Row>
        <Col>
            <Asistente />
        </Col>
    </Row>
  )
}

export default ViewAsistente